"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GameScene = void 0;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class GameScene extends Phaser.Scene {
  get gameHeight() {
    return this.game.config.height;
  }
  get gameWidth() {
    return this.game.config.width;
  }
  constructor(key) {
    super(key);
    _defineProperty(this, "camera", null);
    _defineProperty(this, "background", null);
    _defineProperty(this, "gameText", null);
    _defineProperty(this, "isGameRunning", false);
    _defineProperty(this, "selectedCogTiltLeftBlock", null);
    _defineProperty(this, "selectedCogTiltRightBlock", null);
  }
}
exports.GameScene = GameScene;